import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const Container = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #1e4d92 0%, #2d8fe5 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 20px;
`;

const Header = styled.header`
  width: 100%;
  padding: 2rem;
  text-align: center;
  margin-top: 50px;
`;

const Logo = styled.h1`
  font-size: 4.5rem;
  font-weight: bold;
  color: white;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    font-size: 3rem;
  }
`;

const MainContent = styled.main`
  max-width: 800px;
  width: 100%;
  margin: 40px auto;
  text-align: center;
  padding: 2rem;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
`;

const Description = styled.p`
  font-size: 1.8rem;
  color: white;
  line-height: 1.6;
  margin-bottom: 3rem;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    font-size: 1.4rem;
  }
`;

const Button = styled.button`
  padding: 1.5rem 3rem;
  font-size: 1.8rem;
  font-weight: bold;
  background-color: white;
  color: #1e4d92;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
    background-color: #f0f0f0;
  }

  @media (max-width: 768px) {
    padding: 1.2rem 2.4rem;
    font-size: 1.4rem;
  }
`;

const AdminLink = styled(Link)`
  position: fixed;
  bottom: 20px;
  right: 20px;
  padding: 10px 20px;
  background: rgba(30, 77, 146, 0.1);
  color: #1e4d92;
  text-decoration: none;
  border-radius: 5px;
  font-size: 0.9rem;

  &:hover {
    background: rgba(30, 77, 146, 0.2);
  }
`;

const LandingPage = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <Header>
        <Logo>QR Salve</Logo>
      </Header>
      <MainContent>
        <Description>
          Seu QR Code médico para emergências.<br/>
          Mantenha suas informações médicas importantes sempre acessíveis e seguras.
        </Description>
        <Button onClick={() => navigate('/register')}>
          Criar Meu QR Code
        </Button>
      </MainContent>
      <AdminLink to="/admin">Admin</AdminLink>
    </Container>
  );
};

export default LandingPage;